import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'

import { Container } from '@/components/Container'
import { Head } from '@/components/Head'
import { Header } from '@/components/Header'
import { Layout } from '@/components/Layout'
import { MyCollections } from '@/components/MyCollections'
import { RequireWalletAccess } from '@/components/RequireWalletAccess'
import { useMetaMask } from '@/hooks/useMetaMask'
import { useOpenSea } from '@/hooks/useOpenSea'
import { getMyAssets } from '@/lib/OpenSea'

const assetsLimit = 20

const Collections = () => {
  const router = useRouter()
  const metamask = useMetaMask()
  const { account, currentChainId, web3 } = metamask
  const opensea = useOpenSea({ web3, currentChainId })
  const { seaport } = opensea
  const [tokenIds, setTokenIds] = useState<number[]>([])
  const [page, setPage] = useState(1)
  const [isCollectionLoading, setIsCollectionLoading] = useState(true)
  const [isLastPage, setIsLastPage] = useState(false)

  useEffect(() => {
    const page = Number(router.query.page)
    if (page > 0) {
      setPage(page)
    }
  }, [router.query.page])

  useEffect(() => {
    if (!seaport || !account) {
      return
    }

    const fetchAssets = async () => {
      setIsCollectionLoading(true)
      const limit = assetsLimit + 1
      const offset = assetsLimit * (page - 1)
      const response = await getMyAssets({
        seaport,
        account,
        query: {
          limit,
          offset,
          order_by: 'pk',
          order_direction: 'asc',
        },
        page,
      })
      const ids = response.assets.map((asset) => {
        const tokenId = asset.name.split(' ')[0].substr(1)
        return Number(tokenId)
      })

      setIsLastPage(ids.length > assetsLimit ? false : true)
      setTokenIds(ids.slice(0, assetsLimit))
      setIsCollectionLoading(false)
    }

    fetchAssets()
  }, [seaport, account, page])

  const onClickNextPage = () => {
    router.push(`/collections?page=${page + 1}`, undefined, { shallow: true })
  }

  const onClickPrevPage = () => {
    const prevPage = page - 1 > 0 ? page - 1 : page
    router.push(`/collections?page=${prevPage}`, undefined, { shallow: true })
  }

  return (
    <Layout>
      <Head path="/collections" />
      <Container>
        <Header />
        <RequireWalletAccess metamask={metamask} opensea={opensea}>
          <MyCollections
            ids={tokenIds}
            page={page}
            isLoading={isCollectionLoading}
            isLastPage={isLastPage}
            onClickPrevPage={onClickPrevPage}
            onClickNextPage={onClickNextPage}
          />
        </RequireWalletAccess>
      </Container>
    </Layout>
  )
}

export default Collections
